import { z } from 'zod';

/* =====================================================================
   Primitivos Zod reutilizables. Viven aquí (no en index.ts) para evitar
   ciclos de imports cuando los schemas hijos los consumen.
===================================================================== */

export const requiredString = (label = 'Este campo') =>
  z.string({ error: `${label} es obligatorio` }).min(1, `${label} es obligatorio`);
